import { HeadingTwo } from '~/@mid_ui/typography/HeadingTwo'
import { Text } from '~/@mid_ui/typography/Text'
import { Button } from '~/shadcn/ui/button/button'

type Props = {
  onClose: () => void
}

function CompanyConfirmationAdmin({ onClose }: Props) {
  return (
    <div className="flex flex-col items-center">
      <HeadingTwo className="mb-8">
        Prebieha manuálne overenie vašich údajov
      </HeadingTwo>
      <Text className="text-sm font-thin text-[1rem] text-center lg:text-left">
        Tento úkon môže trvať niekoľko (obyčajne max. 5 pracovných) dní. O
        výsledku overenia budete informovaný. V prípade, že bude potrebné
        doplniť nejaké údaje, spojí sa s vami naše administratívne oddelenie.
      </Text>
      <div className="flex justify-center">
        <img
          src="/images/firma-cakanie.png"
          alt="firma-overenie-udajov"
          width={420}
          height={315}
        />
      </div>
      <div className="flex justify-center">
        <Button variant="accent" onClick={onClose} size="lg">
          Rozumiem
        </Button>
      </div>
    </div>
  )
}

export { CompanyConfirmationAdmin }
